export type ValuationLike = {
    global?: Record<string, number> | null;
    local?: Record<string, number> | null;
};

export function resolveValuation(
    valuation: ValuationLike | null | undefined,
    currency: string,
): number | null {
    const g = valuation?.global?.[currency];
    if (g != null) return g;

    const l = valuation?.local?.[currency];
    if (l != null) return l;

    return null;
}
